import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ebe5d98")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", {
    class: ["module line-numbers", [ _ctx.module.type ]]
  }, [
    _createVNode("img", {
      srcset: _ctx.module.image.imageNsfw && !_ctx.appState.showNsfw ? _ctx.module.image.imageModuleInlineNsfwSrcSet : _ctx.module.image.imageModuleInlineSrcSet,
      src: _ctx.module.image.imageNsfw && !_ctx.appState.showNsfw ? _ctx.module.image.nsfwUrl : _ctx.module.image.url,
      alt: _ctx.module.image.title,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onImageClick(_ctx.index)))
    }, null, 8, ["srcset", "src", "alt"])
  ], 2))
})